function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { notifications_title, notifications_tabs_all, notifications_tabs_mentions, notifications_tabs_replies, notifications_tabs_likes, notifications_tabs_retweets, notifications_emptyMessage_all, notifications_emptyMessage_filtered } from '@paraglide/messages';
import { TabNav } from "@edusense/shared-ui-layout";
import { NotificationSettings } from "../NotificationSettings";
import { NOTIFICATION_TEST_IDS } from "@edusense/shared-constants";
import { Button } from "@heroui/react";
import { ArrowLeft, Settings } from "lucide-react";
/**
 * Notifications page template component
 *
 * Template-level component in Atomic Design
 * Includes notification list and filtering tabs.
 */ var NotificationsTemplate = function(param) {
    var notifications = param.notifications, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, currentUserId = param.currentUserId, onTabChange = param.onTabChange, onNotificationClick = param.onNotificationClick, onMarkAsRead = param.onMarkAsRead, onNavigate = param.onNavigate;
    var _useState = _sliced_to_array(useState('all'), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    var _useState1 = _sliced_to_array(useState('list'), 2), activeView = _useState1[0], setActiveView = _useState1[1];
    // Tab definitions
    var tabs = [
        {
            id: 'all',
            label: notifications_tabs_all()
        },
        {
            id: 'mentions',
            label: notifications_tabs_mentions()
        },
        {
            id: 'replies',
            label: notifications_tabs_replies()
        },
        {
            id: 'likes',
            label: notifications_tabs_likes()
        },
        {
            id: 'retweets',
            label: notifications_tabs_retweets()
        }
    ];
    // Get filtered notification list
    var getFilteredNotifications = function() {
        if (activeTab === 'all') {
            return notifications;
        }
        var typeMapping = {
            'mentions': 'MENTION',
            'replies': 'REPLY',
            'likes': 'LIKE',
            'retweets': 'RETWEET'
        };
        var filterType = typeMapping[activeTab];
        return notifications.filter(function(notif) {
            return notif.type === filterType;
        });
    };
    // Tab change handler
    var handleTabChange = function(tabId) {
        setActiveTab(tabId);
        if (onTabChange) {
            onTabChange(tabId);
        }
    };
    var handleOpenSettings = function() {
        if (!currentUserId) {
            return;
        }
        setActiveView('settings');
    };
    var renderListView = function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "px-4 pb-8"
        }, isLoading ? /*#__PURE__*/ React.createElement("div", {
            className: "py-12 text-center text-gray-500 dark:text-gray-400"
        }, "불러오는 중...") : function() {
            var filtered = getFilteredNotifications();
            if (!filtered.length) {
                var _tabs_find;
                var label = ((_tabs_find = tabs.find(function(tab) {
                    return tab.id === activeTab;
                })) === null || _tabs_find === void 0 ? void 0 : _tabs_find.label) || '';
                var emptyMessage = activeTab === 'all' ? notifications_emptyMessage_all() : notifications_emptyMessage_filtered({
                    tab: label
                });
                return /*#__PURE__*/ React.createElement("div", {
                    className: "py-12 text-center text-gray-500 dark:text-gray-400",
                    "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_LIST_CONTAINER
                }, emptyMessage);
            }
            return /*#__PURE__*/ React.createElement("ul", {
                className: "space-y-3",
                "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_LIST_CONTAINER
            }, filtered.map(function(notification) {
                var _notification_sender, _notification_sender1, _notification_sender2, _notification_sender3;
                var _notification_isRead;
                var isRead = (_notification_isRead = notification.isRead) !== null && _notification_isRead !== void 0 ? _notification_isRead : false;
                var senderName = ((_notification_sender = notification.sender) === null || _notification_sender === void 0 ? void 0 : _notification_sender.name) || ((_notification_sender1 = notification.sender) === null || _notification_sender1 === void 0 ? void 0 : _notification_sender1.username) || '알 수 없음';
                var senderHandle = ((_notification_sender2 = notification.sender) === null || _notification_sender2 === void 0 ? void 0 : _notification_sender2.username) ? "@".concat(notification.sender.username) : '';
                var avatar = (_notification_sender3 = notification.sender) === null || _notification_sender3 === void 0 ? void 0 : _notification_sender3.profileImage;
                var createdAt = notification.createdAt ? new Date(notification.createdAt) : null;
                return /*#__PURE__*/ React.createElement("li", {
                    key: notification.id,
                    className: "flex gap-3 px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-800 transition-all ".concat(isRead ? 'bg-white dark:bg-gray-900' : 'bg-blue-50 dark:bg-slate-800/60 border-blue-200 dark:border-slate-700'),
                    onClick: function() {
                        return onNotificationClick === null || onNotificationClick === void 0 ? void 0 : onNotificationClick(notification);
                    }
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "flex-shrink-0 w-12 h-12 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700"
                }, avatar ? // eslint-disable-next-line @next/next/no-img-element
                /*#__PURE__*/ React.createElement("img", {
                    src: avatar,
                    alt: senderName,
                    className: "w-full h-full object-cover"
                }) : /*#__PURE__*/ React.createElement("div", {
                    className: "w-full h-full flex items-center justify-center text-sm text-gray-500"
                }, senderName.slice(0, 2))), /*#__PURE__*/ React.createElement("div", {
                    className: "flex-1 min-w-0"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400"
                }, /*#__PURE__*/ React.createElement("span", {
                    className: "font-medium text-gray-900 dark:text-white"
                }, senderName), senderHandle && /*#__PURE__*/ React.createElement("span", null, senderHandle), createdAt && /*#__PURE__*/ React.createElement("span", {
                    "aria-hidden": "true"
                }, "\xb7"), createdAt && /*#__PURE__*/ React.createElement("time", {
                    dateTime: createdAt.toISOString()
                }, new Intl.RelativeTimeFormat('ko', {
                    numeric: 'auto'
                }).format(Math.round((createdAt.getTime() - Date.now()) / (1000 * 60 * 60)), 'hour'))), /*#__PURE__*/ React.createElement("div", {
                    className: "mt-1 text-sm text-gray-700 dark:text-gray-200 leading-relaxed"
                }, notification.tweetContent || notification.message || '새로운 알림이 도착했습니다.'), !isRead && /*#__PURE__*/ React.createElement("button", {
                    type: "button",
                    onClick: function(event) {
                        event.stopPropagation();
                        onMarkAsRead === null || onMarkAsRead === void 0 ? void 0 : onMarkAsRead(notification.id);
                    },
                    className: "mt-2 text-xs text-blue-600 dark:text-blue-400 hover:underline"
                }, "읽음 처리")));
            }));
        }());
    };
    var renderSettingsView = function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-col flex-1 bg-white dark:bg-gray-900",
            "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_MODAL
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex-1 overflow-y-auto px-4 pb-8"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "max-w-3xl mx-auto pt-4"
        }, currentUserId ? /*#__PURE__*/ React.createElement(NotificationSettings, {
            userId: currentUserId
        }) : /*#__PURE__*/ React.createElement("div", {
            className: "py-12 text-center text-gray-500 dark:text-gray-400"
        }, "사용자 정보를 불러올 수 없습니다."))));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col min-h-screen bg-white dark:bg-gray-900"
    }, /*#__PURE__*/ React.createElement("header", {
        className: "sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800"
    }, activeView === 'list' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "px-4 py-3 flex items-center justify-between"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-xl font-bold text-gray-900 dark:text-white"
    }, notifications_title()), /*#__PURE__*/ React.createElement(Button, {
        isIconOnly: true,
        variant: "light",
        onClick: handleOpenSettings,
        isDisabled: !currentUserId,
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_BUTTON,
        "aria-label": "알림 설정"
    }, /*#__PURE__*/ React.createElement(Settings, {
        className: "w-5 h-5"
    }))), /*#__PURE__*/ React.createElement(TabNav, {
        tabs: tabs,
        activeTabId: activeTab,
        onTabChange: handleTabChange,
        className: "px-4"
    })) : /*#__PURE__*/ React.createElement("div", {
        className: "px-4 py-3 flex items-center gap-3"
    }, /*#__PURE__*/ React.createElement(Button, {
        isIconOnly: true,
        variant: "light",
        onClick: function() {
            return setActiveView('list');
        },
        "aria-label": "알림 목록으로 돌아가기"
    }, /*#__PURE__*/ React.createElement(ArrowLeft, {
        className: "w-5 h-5"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-xl font-bold text-gray-900 dark:text-white"
    }, "알림 설정"), /*#__PURE__*/ React.createElement("p", {
        className: "text-sm text-gray-500 dark:text-gray-400"
    }, "알림 채널과 조용한 시간을 한 곳에서 관리하세요.")))), /*#__PURE__*/ React.createElement("main", {
        className: "flex-grow"
    }, activeView === 'list' ? renderListView() : renderSettingsView()));
};
export default NotificationsTemplate;
